import { reactive } from "vue";
import type { DraggerType } from "@/drawing";

/**
 * Which base-point edit tool (COPY / MOVE / ROTATE / SCALE) is running, if any.
 *
 * These tools are launched straight through Facade.tools.activate() and
 * deliberately never touch DraggerMenuState.activeDragger — that helper clears
 * the selection they operate on. So DraggerMenuState still names the *previous*
 * tool for their whole lifetime, and nothing reactive says one of them is up.
 * This store is that signal, shared by the two places that need it:
 * SelectionMenu (its in-progress bar) and TypedInputPanel (which tool's keypad
 * spec to re-subscribe to).
 *
 * Session-only, like MeasurementKeypadState — never persisted.
 */
type BasePointToolState = {
  active: DraggerType | null;
  /** Whether the current step accepts typed values, so the pad is worth offering. */
  canTypeInput: boolean;
};

export default reactive<BasePointToolState>({
  active: null,
  canTypeInput: false,
});
